<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='专题列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="15">
          <el-button type="primary" @click="showAddDialog">添加主题封面</el-button>&nbsp;
          <el-select v-model="param.category_id" placeholder="请选择分类" filterable @change="search">
            <el-option label="请选择分类" :value="0"></el-option>
            <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>&nbsp;
          <el-input v-model="param.keywords" placeholder="请输入专题名称关键字" style="width: 300px;" clearable @clear="search" @keyup.enter.native="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column prop="year" label="年份" align="center" ></el-table-column>
        <el-table-column prop="title" label="名称" align="center"></el-table-column>
        <el-table-column label="分类" align="center">
          <template slot-scope="scope">
            {{scope.row.category_id | getTitleById(categoryList)}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="sort" label="排序" align="center" width="80px"></el-table-column> -->
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pic!=''" :src="scope.row.pic+'?imageView2/0/h/50'" class="list_img"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" align="center">
          <template slot-scope="scope">
            {{scope.row.publish_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="success" icon="el-icon-edit" size="mini" @click="showContentDialog(scope.row.id)">文章列表</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :current-page="param.page"
       :page-sizes="[10, 20, 30, 40, 50]"
       :page-size="param.count"
       layout="total, sizes, prev, pager, next, jumper"
       :total="total">
     </el-pagination>
    </el-card>
    <special-add :visible="addDialogAvaible"
      :id="currentId"
      :categoryList="categoryList"
      @add="add"
      @update="update"
      @closeDialog="closeAddDialog">
    </special-add>
    <special-content :visible="contentDialogAvaible"
      :id="currentId"
      @closeDialog="closeContentDialog">
    </special-content>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import SpecialAdd from './SpecialAdd.vue'
import SpecialContent from './SpecialContentList.vue'
export default {
  name: 'special_list',
  components: {
    'bread-crumb': BreadCrumb,
    'special-add': SpecialAdd,
    'special-content': SpecialContent
  },
  created () {
    this.getCategoryList()
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      list: [],
      categoryList: [],
      addDialogAvaible: false,
      contentDialogAvaible: false,
      roleId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10,
        keywords: ''
      }
    }
  },
  filters: {
    getTitleById (id, valueList) {
      for (var i = 0; i < valueList.length; i++) {
        if (id === valueList[i].id) {
          return valueList[i].title
        }
      }
      return ''
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/special/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
      this.roleId = parseInt(window.sessionStorage.getItem('role_id'))
    },
    async getCategoryList () {
      const res = await this.$http.get('/admin/special_category/select_list', this.param)
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async add (data) {
      const res = await this.$http.post('/admin/special/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/special/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    showContentDialog (id) {
      this.currentId = id
      this.contentDialogAvaible = true
    },
    closeContentDialog () {
      this.contentDialogAvaible = false
      this.currentId = 0
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/special/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
}
</style>
